import { render, staticRenderFns } from "./BasicInvestigation.vue?vue&type=template&id=4fb6df9e&"
import script from "./BasicInvestigation.vue?vue&type=script&lang=ts&"
export * from "./BasicInvestigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb6df9e')) {
      api.createRecord('4fb6df9e', component.options)
    } else {
      api.reload('4fb6df9e', component.options)
    }
    module.hot.accept("./BasicInvestigation.vue?vue&type=template&id=4fb6df9e&", function () {
      api.rerender('4fb6df9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/investigations/BasicInvestigation.vue"
export default component.exports